// import React, { useState, useEffect } from "react";
// import { Card, CardBody, Row, Col, Input, Button } from "reactstrap";
// import Select from "react-select";
// import Handler from "../../Helpers/Handler";
// import { toast } from "react-toastify";
// import { useParams, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { loadingFalse, loadingTrue } from "../../Reducer/loaderSlice";

// const EditProduct = () => {
//     const dispatch = useDispatch();
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const user = useSelector(s => s.customer.customer);
//     const loading = useSelector(s => s.loading.loading);
//     const discountTypes = [
//         { value: "flat", label: "Flat" },
//         { value: "percentage", label: "Percentage" }
//     ];

//     const unitOptions = [
//         { value: "g", label: "Gram (g)" },
//         { value: "kg", label: "Kilogram (kg)" },
//         { value: "ml", label: "Millilitre (ml)" },
//         { value: "ltr", label: "Litre (ltr)" },
//         { value: "pcs", label: "Pieces (pcs)" }
//     ];

//     const [categories, setCategories] = useState([]);
//     const [subCategories, setSubCategories] = useState([]);

//     const [form, setForm] = useState({
//         name: "",
//         sku: "",
//         brand: "",
//         description: "",
//         price: "",
//         purchase_price: "",
//         gst_rate: "",
//         stock: "",
//         quantity: "",
//         unit: null,
//         low_stock_limit: "",
//         discount_type: null,
//         discount_value: "",
//         category: null,
//         sub_category: null
//     });

//     const [variants, setVariants] = useState([]);

//     /* LOAD MASTER DATA */
//     useEffect(() => {
//         loadCategories();
//         loadProduct();
//     }, []);

//     const loadCategories = async () => {
//         const res = await Handler({ method: "get", url: "/categories/list.php?limit=1000" });
//         if (res?.success) {
//             setCategories(res.data.categories.map(c => ({ value: c.id, label: c.name })));
//         }
//     };

//     const loadSubCategories = async (cid, selected) => {
//         const res = await Handler({
//             method: "get",
//             url: `/sub_categories/list.php?category_id=${cid}&limit=1000`
//         });
//         if (res?.success) {
//             const opts = res.data.sub_categories.map(sc => ({ value: sc.id, label: sc.name }));
//             setSubCategories(opts);
//             if (selected) {
//                 setForm(p => ({ ...p, sub_category: opts.find(o => o.label === selected) }));
//             }
//         }
//     };

//     /* LOAD PRODUCT */
//     const loadProduct = async () => {
//         const res = await Handler({ method: "get", url: `/products/view.php?id=${id}` });

//         if (!res?.success) return toast.error("Failed to load product");

//         const d = res.data;

//         // const [qty, unit] = d?.meta?.size.split(" ");
//         const size = d.meta?.size || "";
//         const match = size.match(/^(\d+)\s*(\w+)$/);

//         const qty = match ? match[1] : "";
//         const unit = match ? match[2] : "";

//         setForm({
//             name: d.name,
//             sku: d.meta.sku,
//             brand: d.meta.brand,
//             dealer: d.meta.dealer,
//             description: d.meta.description,
//             price: d.price,
//             purchase_price: d.meta.purchase_price,
//             gst_rate: d.gst_rate,
//             stock: d.quantity,
//             quantity: qty,
//             unit: unitOptions.find(u => u?.value === unit),
//             low_stock_limit: d?.low_stock_limit,
//             discount_type: discountTypes.find(t => t?.value === d?.meta?.discount?.type),
//             discount_value: d?.meta?.discount?.value,
//             category: { value: null, label: d?.category_name },
//             sub_category: { value: null, label: d?.sub_category_name }
//         });

//         loadSubCategories(null, d.sub_category_name);

//         setVariants(
//             d.variants.length
//                 ? d.variants.map(v => ({
//                     id: v.variant_id,
//                     name: v.name,
//                     price: v.price,
//                     purchase_price: v.meta.purchase_price || 0,
//                     discount_type: discountTypes.find(t => t?.value === v?.meta?.discount?.type) || null,
//                     discount_value: v?.meta?.discount?.value || "",
//                     gst_rate: v.gst_rate,
//                     quantity: v.quantity,
//                     low_stock_limit: v.low_stock_limit
//                 }))
//                 : []
//         );
//     };

//     /* UPDATE VARIANT */
//     const updateVariant = (i, k, v) => {
//         const copy = [...variants];
//         copy[i][k] = v;
//         setVariants(copy);
//     };

//     /* SUBMIT */
//     const submit = async () => {
//         if (Number(form.price) < Number(form.purchase_price)) {
//             return toast.error("Main Product: Selling price cannot be less than Purchase price");
//         }

//         for (let i = 0; i < variants.length; i++) {
//             const v = variants[i];
//             // Selling price purchase price-ah vida kammiya irukknu check panrom
//             if (Number(v.price) < Number(v.purchase_price)) {
//                 return toast.error(`Variant "${v.name || i + 1}": Selling price cannot be less than Purchase price`);
//             }
//         }
//         dispatch(loadingTrue());
//         // const payload = {
//         //     product_id: id,
//         //     name: form.name,
//         //     brand: form.brand,
//         //     dealer: form.dealer,
//         //     price: Number(form.price),
//         //     purchase_price: Number(form.purchase_price),
//         //     discount_type: form.discount_type?.value,
//         //     discount_value: Number(form.discount_value),
//         //     gst_rate: Number(form.gst_rate),
//         //     size: `${form.quantity} ${form.unit?.value}`,
//         //     quantity: Number(form.stock),
//         //     low_stock_limit: Number(form.low_stock_limit),
//         //     description: form.description,
//         //     variants: variants.map(v => ({
//         //         variant_id: v.id,
//         //         name: v.name,
//         //         price: Number(v.price),
//         //         purchase_price: Number(v.purchase_price),
//         //         discount_type: v.discount_type?.value,
//         //         discount_value: Number(v.discount_value),
//         //         gst_rate: Number(v.gst_rate || 0),
//         //         quantity: Number(v.quantity),
//         //         low_stock_limit: Number(v.low_stock_limit)
//         //     }))
//         // };

//         const payload = {
//             product_id: id,
//             name: form.name,
//             brand: form.brand,
//             dealer: form.dealer,
//             price: Number(form.price),
//             purchase_price: Number(form.purchase_price),

//             discount_type: form?.discountType?.value,
//             discount_value: Number(form?.discount_value),

//             gst_rate: Number(form.gst_rate),
//             size: `${form.quantity} ${form.unit?.value}`,
//             quantity: Number(form.stock),
//             low_stock_limit: Number(form.low_stock_limit),
//             description: form.description,

//             category_id: form.category?.value,
//             sub_category_id: form.sub_category?.value,

//             variants: variants.map(v => ({
//                 variant_id: v.id,
//                 name: v.name,
//                 price: Number(v.price),
//                 purchase_price: Number(v.purchase_price),
//                 ...(v.discount_type?.value && v.discount_value !== "" && {
//                     discount_type: v.discount_type.value,
//                     discount_value: Number(v.discount_value)
//                 }),
//                 gst_rate: Number(v.gst_rate || 0),
//                 quantity: Number(v.quantity),
//                 low_stock_limit: Number(v.low_stock_limit)
//             }))
//         };

//         const res = await Handler({ method: "post", url: "/products/update.php", data: { ...payload, outlet_id: user?.outlet_id } });
//         if (res?.success) {
//             toast.success("Product updated")
//             navigate("/products")
//             dispatch(loadingFalse());
//         }
//         else {
//             toast.error(res?.message)
//             dispatch(loadingFalse());
//         }
//     };

//     return (
//         <>
//             <Row className="mb-4">
//                 <Col><h4 className="fw-bold">Edit Product</h4></Col>
//             </Row>

//             {/* ================= PRODUCT ================= */}
//             <Card className="mb-4"><CardBody>

//                 <Row className="g-3 mb-4">
//                     <Col md={6}>
//                         <label>Product Name *</label>
//                         <Input placeholder="Enter product name" value={form.name}
//                             onChange={e => setForm({ ...form, name: e.target.value })} />
//                     </Col>
//                     <Col md={6}>
//                         <label>SKU</label>
//                         <Input placeholder="Auto generated" value={form.sku} readOnly />
//                     </Col>
//                 </Row>

//                 <Row className="g-3 mb-4">
//                     <Col md={6}>
//                         <label>Dealer Name</label>
//                         <Input placeholder="Dealer name" value={form.dealer}
//                             onChange={e => setForm({ ...form, dealer: e.target.value })} />
//                     </Col>
//                     <Col md={6}>
//                         <label>Brand</label>
//                         <Input placeholder="Brand" value={form.brand}
//                             onChange={e => setForm({ ...form, brand: e.target.value })} />
//                     </Col>
//                 </Row>

//                 <Row className="g-3 mb-4">
//                     <Col md={4}>
//                         <label>Price *</label>
//                         <Input type="number" placeholder="Selling price" value={form.price}
//                             onChange={(e) => {
//                                 if (/^\d*$/.test(e.target.value)) {
//                                     setForm({ ...form, price: e.target.value });
//                                 }
//                             }} />
//                     </Col>
//                     <Col md={4}>
//                         <label>Purchase Price *</label>
//                         <Input type="number" placeholder="Purchase price" value={form.purchase_price}
//                             onChange={(e) => {
//                                 if (/^\d*$/.test(e.target.value)) {
//                                     setForm({ ...form, purchase_price: e.target.value });
//                                 }
//                             }} />
//                     </Col>
//                     <Col md={4}>
//                         <label>GST % *</label>
//                         <Input type="number" placeholder="GST %" value={form.gst_rate}
//                             onChange={(e) => {
//                                 if (/^\d*$/.test(e.target.value)) {
//                                     setForm({ ...form, gst_rate: e.target.value });
//                                 }
//                             }} />
//                     </Col>

//                     <Col md={6}>
//                         <label>Unit *</label>
//                         <Select
//                             options={unitOptions}
//                             value={form.unit}
//                             onChange={v => setForm({ ...form, unit: v })}
//                         />
//                     </Col>
//                     <Col md={6}>
//                         <label>Quantity *</label>
//                         <Input type="number" placeholder="0 allowed"
//                             value={form.quantity}
//                             onChange={(e) => {
//                                 if (/^\d*$/.test(e.target.value)) {
//                                     setForm({ ...form, quantity: e.target.value });
//                                 }
//                             }} />
//                     </Col>

//                 </Row>

//                 <Row className="g-3 mb-4">
//                     <Col md={4}>
//                         <label>Discount Type</label>
//                         <Select options={discountTypes} value={form.discount_type}
//                             onChange={v => setForm({ ...form, discount_type: v })} />
//                     </Col>
//                     <Col md={4}>
//                         <label>Discount Value</label>
//                         <Input type="number" placeholder="Discount value"
//                             value={form.discount_value}
//                             onChange={(e) => {
//                                 if (/^\d*$/.test(e.target.value)) {
//                                     setForm({ ...form, discount_value: e.target.value });
//                                 }
//                             }} />
//                     </Col>

//                     <Col md={4}>
//                         <label>Stock</label>
//                         <Input type="number" placeholder="0 allowed"
//                             value={form.stock}
//                             onChange={(e) => {
//                                 if (/^\d*$/.test(e.target.value)) {
//                                     setForm({ ...form, stock: e.target.value });
//                                 }
//                             }} />
//                     </Col>
//                 </Row>

//                 <Row className="g-3 mb-4">
//                     <Col md={4}>
//                         <label>Category *</label>
//                         <Select options={categories} value={form.category}
//                             onChange={v => { setForm({ ...form, category: v, sub_category: null }); loadSubCategories(v.value); }} />
//                     </Col>
//                     <Col md={4}>
//                         <label>Sub Category *</label>
//                         <Select options={subCategories} value={form.sub_category}
//                             onChange={v => setForm({ ...form, sub_category: v })} />
//                     </Col>
//                     <Col md={4}>
//                         <label>Low Stock Limit</label>
//                         <Input type="number" placeholder="Low stock alert"
//                             value={form.low_stock_limit}
//                             onChange={(e) => {
//                                 if (/^\d*$/.test(e.target.value)) {
//                                     setForm({ ...form, low_stock_limit: e.target.value });
//                                 }
//                             }} />
//                     </Col>
//                 </Row>

//                 <Row>
//                     <Col>
//                         <label>Description</label>
//                         <Input type="textarea" rows="3" placeholder="Product description"
//                             value={form.description}
//                             onChange={e => setForm({ ...form, description: e.target.value })} />
//                     </Col>
//                 </Row>

//             </CardBody></Card>

//             {/* ================= VARIANTS ================= */}
//             <Card className="mb-4"><CardBody>

//                 {variants && variants?.map((v, i) => (
//                     <div key={i} className="border border-light rounded p-3 mb-3 bg-light bg-opacity-10">

//                         <Row className="g-3 mb-3">
//                             <Col md={4}>
//                                 <label>Variant Name *</label>
//                                 <Input placeholder="Variant name" value={v.name}
//                                     onChange={e => updateVariant(i, "name", e.target.value)} />
//                             </Col>
//                             <Col md={4}>
//                                 <label>Price *</label>
//                                 <Input type="number" placeholder="Selling price" value={v.price}
//                                     onChange={e => updateVariant(i, "price", e.target.value)} />
//                             </Col>
//                             <Col md={4}>
//                                 <label>Purchase Price *</label>
//                                 <Input type="number" placeholder="Purchase price" value={v.purchase_price}
//                                     onChange={e => updateVariant(i, "purchase_price", e.target.value)} />
//                             </Col>
//                         </Row>

//                         <Row className="g-3 mb-3">
//                             <Col md={4}>
//                                 <label>Discount Type</label>
//                                 <Select options={discountTypes} value={v.discount_type}
//                                     onChange={val => updateVariant(i, "discount_type", val)} />
//                             </Col>
//                             <Col md={4}>
//                                 <label>Discount Value</label>
//                                 <Input type="number" placeholder="Discount value"
//                                     value={v.discount_value}
//                                     onChange={e => updateVariant(i, "discount_value", e.target.value)} />
//                             </Col>
//                             <Col md={4}>
//                                 <label>GST % *</label>
//                                 <Input type="number" placeholder="GST %"
//                                     value={v.gst_rate}
//                                     onChange={e => updateVariant(i, "gst_rate", e.target.value)} />
//                             </Col>
//                         </Row>

//                         <Row className="g-3">
//                             <Col md={6}>
//                                 <label>Stock</label>
//                                 <Input type="number" placeholder="0 allowed" value={v.quantity}
//                                     onChange={e => updateVariant(i, "quantity", e.target.value)} />
//                             </Col>
//                             <Col md={6}>
//                                 <label>Low Stock Limit</label>
//                                 <Input type="number" placeholder="Low stock alert"
//                                     value={v.low_stock_limit}
//                                     onChange={e => updateVariant(i, "low_stock_limit", e.target.value)} />
//                             </Col>
//                         </Row>

//                     </div>
//                 ))}

//             </CardBody></Card>
//             <div className="text-end">
//                 <Button disabled={loading} color="success" onClick={submit}>Update Product</Button>
//             </div>
//         </>
//     );
// };

// export default EditProduct;

import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Col, Input, Button } from "reactstrap";
import Select from "react-select";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadingFalse, loadingTrue } from "../../Reducer/loaderSlice";

const EditProduct = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    const user = useSelector(s => s.customer.customer);
    const loading = useSelector(s => s.loading.loading);

    const discountTypes = [
        { value: "flat", label: "Flat" },
        { value: "percentage", label: "Percentage" }
    ];

    const unitOptions = [
        { value: "g", label: "Gram (g)" },
        { value: "kg", label: "Kilogram (kg)" },
        { value: "ml", label: "Millilitre (ml)" },
        { value: "ltr", label: "Litre (ltr)" },
        { value: "pcs", label: "Pieces (pcs)" }
    ];

    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);

    const [form, setForm] = useState({
        name: "", sku: "", brand: "", dealer: "", description: "",
        price: "", purchase_price: "", gst_rate: "", stock: "",
        quantity: "", unit: null, low_stock_limit: "",
        discount_type: null, discount_value: "",
        category: null, sub_category: null
    });

    const [variants, setVariants] = useState([]);

    useEffect(() => {
        const init = async () => {
            dispatch(loadingTrue());
            const cats = await loadCategories();
            await loadProduct(cats); // Categories load aanathuku apram product load pandrom
            dispatch(loadingFalse());
        };
        init();
    }, []);

    const loadCategories = async () => {
        const res = await Handler({ method: "get", url: "/categories/list.php?limit=1000" });
        if (res?.success) {
            const catOpts = res.data.categories.map(c => ({ value: c.id, label: c.name }));
            setCategories(catOpts);
            return catOpts;
        }
        return [];
    };

    const loadSubCategories = async (cid, selectedName) => {
        if (!cid) return [];
        const res = await Handler({
            method: "get",
            url: `/sub_categories/list.php?category_id=${cid}&limit=1000`
        });
        if (res?.success) {
            const opts = res.data.sub_categories.map(sc => ({ value: sc.id, label: sc.name }));
            setSubCategories(opts);
            return opts;
        }
        return [];
    };

    const loadProduct = async (catOpts) => {
        const res = await Handler({ method: "get", url: `/products/view.php?id=${id}` });
        if (!res?.success) return toast.error("Failed to load product");

        const d = res.data;
        const size = d.meta?.size || "";
        const match = size.match(/^(\d+)\s*(\w+)$/);
        const qty = match ? match[1] : "";
        const unitVal = match ? match[2] : "";

        // Correct Category Object find pandrom
        const selectedCat = catOpts.find(c => c.label === d.category_name) || null;

        // Sub Category load panni set pandrom
        let selectedSub = null;
        if (selectedCat) {
            const subOpts = await loadSubCategories(selectedCat.value);
            selectedSub = subOpts.find(s => s.label === d.sub_category_name) || null;
        }

        setForm({
            name: d.name,
            sku: d.meta?.sku || "",
            brand: d.meta?.brand || "",
            dealer: d.meta?.dealer || "",
            description: d.meta?.description || "",
            price: d.price,
            purchase_price: d.meta?.purchase_price || 0,
            gst_rate: d.gst_rate,
            stock: d.quantity,
            quantity: qty,
            unit: unitOptions.find(u => u.value === unitVal) || null,
            low_stock_limit: d.low_stock_limit,
            discount_type: discountTypes.find(t => t.value === d.meta?.discount?.type) || null,
            discount_value: d.meta?.discount?.value || "",
            category: selectedCat,
            sub_category: selectedSub
        });

        setVariants(
            d.variants?.map(v => ({
                id: v.variant_id,
                name: v.name,
                price: v.price,
                purchase_price: v.meta?.purchase_price || 0,
                discount_type: discountTypes.find(t => t.value === v.meta?.discount?.type) || null,
                discount_value: v.meta?.discount?.value || "",
                gst_rate: v.gst_rate,
                quantity: v.quantity,
                low_stock_limit: v.low_stock_limit
            })) || []
        );
    };

    const updateVariant = (i, k, v) => {
        const copy = [...variants];
        copy[i][k] = v;
        setVariants(copy);
    };

    const submit = async () => {
        if (Number(form.price) < Number(form.purchase_price)) {
            return toast.error("Main Product: Selling price cannot be less than Purchase price");
        }

        dispatch(loadingTrue());
        const payload = {
            product_id: id,
            name: form.name,
            brand: form.brand,
            dealer: form.dealer,
            price: Number(form.price),
            purchase_price: Number(form.purchase_price),
            // Fixed field names here
            discount_type: form.discount_type?.value || null,
            discount_value: Number(form.discount_value || 0),
            gst_rate: Number(form.gst_rate),
            size: `${form.quantity} ${form.unit?.value || ""}`,
            quantity: Number(form.stock),
            low_stock_limit: Number(form.low_stock_limit),
            description: form.description,
            category_id: form.category?.value,
            sub_category_id: form.sub_category?.value,
            variants: variants.map(v => ({
                variant_id: v.id,
                name: v.name,
                price: Number(v.price),
                purchase_price: Number(v.purchase_price),
                discount_type: v.discount_type?.value || null,
                discount_value: Number(v.discount_value || 0),
                gst_rate: Number(v.gst_rate || 0),
                quantity: Number(v.quantity),
                low_stock_limit: Number(v.low_stock_limit)
            }))
        };

        const res = await Handler({
            method: "post",
            url: "/products/update.php",
            data: { ...payload, outlet_id: user?.outlet_id }
        });

        dispatch(loadingFalse());
        if (res?.success) {
            toast.success("Product updated");
            navigate("/products");
        } else {
            toast.error(res?.message || "Update failed");
        }
    };

    return (
        <>
            <Row className="mb-4">
                <Col><h4 className="fw-bold">Edit Product</h4></Col>
            </Row>

            {/* ================= PRODUCT ================= */}
            <Card className="mb-4"><CardBody>

                <Row className="g-3 mb-4">
                    <Col md={6}>
                        <label>Product Name *</label>
                        <Input placeholder="Enter product name" value={form.name}
                            onChange={e => setForm({ ...form, name: e.target.value })} />
                    </Col>
                    <Col md={6}>
                        <label>SKU</label>
                        <Input placeholder="Auto generated" value={form.sku} readOnly />
                    </Col>
                </Row>

                <Row className="g-3 mb-4">
                    <Col md={6}>
                        <label>Dealer Name</label>
                        <Input placeholder="Dealer name" value={form.dealer}
                            onChange={e => setForm({ ...form, dealer: e.target.value })} />
                    </Col>
                    <Col md={6}>
                        <label>Brand</label>
                        <Input placeholder="Brand" value={form.brand}
                            onChange={e => setForm({ ...form, brand: e.target.value })} />
                    </Col>
                </Row>

                <Row className="g-3 mb-4">
                    <Col md={4}>
                        <label>Price *</label>
                        <Input type="number" placeholder="Selling price" value={form.price}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setForm({ ...form, price: e.target.value });
                                }
                            }} />
                    </Col>
                    <Col md={4}>
                        <label>Purchase Price *</label>
                        <Input type="number" placeholder="Purchase price" value={form.purchase_price}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setForm({ ...form, purchase_price: e.target.value });
                                }
                            }} />
                    </Col>
                    <Col md={4}>
                        <label>GST % *</label>
                        <Input type="number" placeholder="GST %" value={form.gst_rate}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setForm({ ...form, gst_rate: e.target.value });
                                }
                            }} />
                    </Col>

                    <Col md={6}>
                        <label>Unit *</label>
                        <Select
                            options={unitOptions}
                            value={form.unit}
                            onChange={v => setForm({ ...form, unit: v })}
                        />
                    </Col>
                    <Col md={6}>
                        <label>Quantity *</label>
                        <Input type="number" placeholder="0 allowed"
                            value={form.quantity}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setForm({ ...form, quantity: e.target.value });
                                }
                            }} />
                    </Col>

                </Row>

                <Row className="g-3 mb-4">
                    <Col md={4}>
                        <label>Discount Type</label>
                        <Select options={discountTypes} value={form.discount_type}
                            onChange={v => setForm({ ...form, discount_type: v })} />
                    </Col>
                    <Col md={4}>
                        <label>Discount Value</label>
                        <Input type="number" placeholder="Discount value"
                            value={form.discount_value}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setForm({ ...form, discount_value: e.target.value });
                                }
                            }} />
                    </Col>

                    <Col md={4}>
                        <label>Stock</label>
                        <Input type="number" placeholder="0 allowed"
                            value={form.stock}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setForm({ ...form, stock: e.target.value });
                                }
                            }} />
                    </Col>
                </Row>

                <Row className="g-3 mb-4">
                    <Col md={4}>
                        <label>Category *</label>
                        <Select options={categories} value={form.category}
                            onChange={v => { setForm({ ...form, category: v, sub_category: null }); loadSubCategories(v.value); }} />
                    </Col>
                    <Col md={4}>
                        <label>Sub Category *</label>
                        <Select options={subCategories} value={form.sub_category}
                            onChange={v => setForm({ ...form, sub_category: v })} />
                    </Col>
                    <Col md={4}>
                        <label>Low Stock Limit</label>
                        <Input type="number" placeholder="Low stock alert"
                            value={form.low_stock_limit}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setForm({ ...form, low_stock_limit: e.target.value });
                                }
                            }} />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <label>Description</label>
                        <Input type="textarea" rows="3" placeholder="Product description"
                            value={form.description}
                            onChange={e => setForm({ ...form, description: e.target.value })} />
                    </Col>
                </Row>

            </CardBody></Card>

            {/* ================= VARIANTS ================= */}
            <Card className="mb-4"><CardBody>

                {variants && variants?.map((v, i) => (
                    <div key={i} className="border border-light rounded p-3 mb-3 bg-light bg-opacity-10">

                        <Row className="g-3 mb-3">
                            <Col md={4}>
                                <label>Variant Name *</label>
                                <Input placeholder="Variant name" value={v.name}
                                    onChange={e => updateVariant(i, "name", e.target.value)} />
                            </Col>
                            <Col md={4}>
                                <label>Price *</label>
                                <Input type="number" placeholder="Selling price" value={v.price}
                                    onChange={e => updateVariant(i, "price", e.target.value)} />
                            </Col>
                            <Col md={4}>
                                <label>Purchase Price *</label>
                                <Input type="number" placeholder="Purchase price" value={v.purchase_price}
                                    onChange={e => updateVariant(i, "purchase_price", e.target.value)} />
                            </Col>
                        </Row>

                        <Row className="g-3 mb-3">
                            <Col md={4}>
                                <label>Discount Type</label>
                                <Select options={discountTypes} value={v.discount_type}
                                    onChange={val => updateVariant(i, "discount_type", val)} />
                            </Col>
                            <Col md={4}>
                                <label>Discount Value</label>
                                <Input type="number" placeholder="Discount value"
                                    value={v.discount_value}
                                    onChange={e => updateVariant(i, "discount_value", e.target.value)} />
                            </Col>
                            <Col md={4}>
                                <label>GST % *</label>
                                <Input type="number" placeholder="GST %"
                                    value={v.gst_rate}
                                    onChange={e => updateVariant(i, "gst_rate", e.target.value)} />
                            </Col>
                        </Row>

                        <Row className="g-3">
                            <Col md={6}>
                                <label>Stock</label>
                                <Input type="number" placeholder="0 allowed" value={v.quantity}
                                    onChange={e => updateVariant(i, "quantity", e.target.value)} />
                            </Col>
                            <Col md={6}>
                                <label>Low Stock Limit</label>
                                <Input type="number" placeholder="Low stock alert"
                                    value={v.low_stock_limit}
                                    onChange={e => updateVariant(i, "low_stock_limit", e.target.value)} />
                            </Col>
                        </Row>

                    </div>
                ))}

            </CardBody></Card>
            <div className="text-end">
                <Button disabled={loading} color="success" onClick={submit}>Update Product</Button>
            </div>
        </>
    );
};

export default EditProduct;